const stateCodes = [
    'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
    'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
    'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
    'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
    'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY',
]
    
export function parseCondition(expression) {
    if (expression === undefined) {
        return undefined
    }
    const restPosition = expression.search('[ !=<>]')
    if (restPosition === -1) {
        const lhs = expression.trim()
        return {lhs, operator: '', rhs: ''}
    }
    const lhs = expression.substring(0, restPosition).trim()

    const rest = expression.substring(restPosition)
    let rhsPosition = rest.search('[^ !=<>]')
    if (rhsPosition === -1) {
        rhsPosition = rest.length
    }
    const rhs = rest.substring(rhsPosition).trim()

    const operator = rest.substring(0, rhsPosition).trim()

    return {lhs, operator, rhs}
}

export function makeChoicesArray(choices) {
    if (choices === undefined || choices === null || choices.trim().length === 0) {
        return []
    }
    let choiceArray = choices.split(",")
    let choicesOut = []
    for (let i in choiceArray) {
        let c = choiceArray[i].trim()
        let index = c.indexOf(':') // TODO: Remove : value for now
        if (index !== -1) {
        c = c.substring(0, index)
        }
        choicesOut[i] = c
    }
    return choicesOut
}

export function question(item, currentSection, choice) {
    let oItem = {...item}
    if (currentSection) {
        oItem['section'] = currentSection.key
        oItem['sectionTitle'] = currentSection.title
    }
    oItem.conditionOrig = item.condition
    oItem.condition = parseCondition(item.condition)

    let type = oItem.type
    switch (type) {
        default: 
            console.log("Unknown type, assuming text: ", JSON.stringify(item, null, 2))
            break
        case 'state':
        case 'choice':
        case 'select':
            if (type === 'state') {
                oItem.type = 'choice'
                oItem.choices = 'state'
            }
            let choices = oItem.choices
            if (choices === undefined) {
                return {error: "Invalid choice or select list"};
            }
            let macro = choice[choices]
            if (macro) {
                oItem.choices = macro
            } else {
                oItem.choices = makeChoicesArray(oItem.choices)
            }
            break;
        case 'valueunit': {
            if (type === 'state') {
                oItem.type = 'choice'
                oItem.choices = 'state'
            }
            let params = oItem.choices
            if (params === undefined) {
                return {error: "Invalid choice, select or parameter list"};
            }
            let [choices, reference] = params.split(',')
            let macro = choice[choices]
            if (macro) {
                oItem.choices = macro
            } else {
                oItem.choices = makeChoicesArray(oItem.choices)
            }
            oItem.reference = reference.trim()
            break;
        }

        // case 'date': oItem.type = 'text'; break
        // case 'number': oItem.type = 'text'; break
        // case 'currency': oItem.type = 'text'; break
        // case 'percentage': oItem.type = 'text'; break
        // case 'integer': oItem.type = 'text'; break

        case 'date': break;
        case 'number': break;
        case 'currency': break;
        case 'percentage':break;
        case 'integer': break;
        case 'text': {
            break; 
        }
        case 'percentdist': 
            break; 
    }
    return oItem
}

function QuestionsAndSections(rawQuestions, answers) {
    let currentSection = undefined
    let choice = {};
    let questions = [];
    let sections = [];

    choice['state'] = stateCodes

    for (let i in rawQuestions) {
        let item = rawQuestions[i]
        try {
            for (let attribute in item) {
                    item[attribute] = item[attribute].trim ? item[attribute].trim() : item[attribute]
            }
        } catch (e) {
            console.log("Attribute error: ", JSON.stringify(item, null, 2))
            continue
        }

        try {
            let control = item.control
            let key     = item.key
            
            if (control === undefined) {
                console.log('Item has no control, ignoring: ', JSON.stringify(item, null, 2))
                continue;
            }
            if (key === undefined) {
                console.log('Item has no key, ignoring: ', JSON.stringify(item, null, 2))
                continue;
            }
            if (control === 'dquestion') {
                item.questionPrompt = item.text
                const text = answers[item.title]
                if (text === undefined) {
                    continue
                }
                item.text = text
            }
            if (control === 'version') {
                ;
            } else if (control === 'section') {
                currentSection = item
                const condition = parseCondition(item.condition)
                const repeat = item.repeat
                const type = item.type
                const choices = item.choices
                sections.push({ key: item.key, title: item.title, condition, repeat, type, choices, questions: []})
            } else if (control === 'choice') {
                choice[key] = makeChoicesArray(item.choices)
            } else if (control === 'question' || control === 'dquestion') {
                const qitem = question(item, currentSection, choice)
                if (item.error !== undefined) {
                    console.error(item.error, JSON.stringify(item, null, 2))
                    continue
                }
                item = qitem
                sections[sections.length-1].questions.push(item)
            } else if (control === 'calculated') {
            } else if (control === 'variable') {
            } else if (control === 'lookup') {
            } else if (control.startsWith('#')) {
            } else if (control === 'product') {
            } else {
                console.log("Unknown control, ignoring: ", JSON.stringify(item, null, 2))
                continue
            }
            questions.push(item)
        } catch(e) {
        }
    }
    return sections
}

export default QuestionsAndSections